/**
 * Zweck: Zeigt die Warenguthaben-Salden je A2-Kundennummer an.
 */
import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {WarenguthabenSaldo} from '../../../../models/warenguthaben-saldo';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'shop.dialogs.warenguthaben-details.component.html',
  standalone: false
})
export class ShopDialogsWarenguthabenDetailsComponent {
  constructor(public dialogRef: MatDialogRef<ShopDialogsWarenguthabenDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) public salden: WarenguthabenSaldo[]) {
  }
}
